module.exports = __webpack_public_path__ + "assets/img/logo-eternia-services.09d5d2d0.webp";